import { render, staticRenderFns } from "./VeeValidate.vue?vue&type=template&id=578145aa&"
import script from "./VeeValidate.vue?vue&type=script&lang=js&"
export * from "./VeeValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports